import { defineQuery } from 'next-sanity'
import { imageFields, linkFields } from '../atoms'

export const careersRoleLinksBlockFields = `
  _id,
  _type,
  variant,
  decorativeShape,
  roleLinks[]{
    _key,
    roleTitle,
    roleDescription,
    roleImage {
      ${imageFields}
    },
    "rolePageButtonLink": rolePageButtonLink{
      ${linkFields}
    },
    backgroundColour
  }
`

export const CAREERS_ROLE_LINKS_BLOCK_QUERY = defineQuery(/* groq */ `
  *[_type == "careers-role-links-block"][0]{
    ${careersRoleLinksBlockFields}
  }
`)
